import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const RepoSecurityLandingPageLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./pages/security-landing-page'),
});

export const RepoSecurityLearnMoreLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./pages/security-learn-more-page'),
});
